export const iconFontAwesomeSpinnersAtom = (
	<i className="fa-solid fa-atom"></i>
);
